import { styled } from '@mui/material/styles';
import * as React from 'react';

export const FlexSpacer: React.FC = styled('div')({flexBasis: 'auto', flexGrow: 1, flexShrink: 1});